export default __webpack_public_path__ + "static/media/address.cfdc1f20.csv";